import React from "react";
import SearchSuggestionsQuestions from "./suggestions/questions";
import SearchSuggestionsArticles from "./suggestions/articles";
import { motion } from "motion/react";
import { Variants } from "../animations/variants";
import { useDialogMount } from "../providers/dialog_state_provider";

export default function SearchSuggestions() {
  // Check if this our first mounting since the dialog was opened
  const hasMounted = useDialogMount("search-suggestions");

  return (
    <div className="dewey--search--suggestions">
      <motion.div
        variants={Variants.FadeInUp}
        initial={hasMounted ? "initial" : false}
        animate="animate"
        exit="exit"
        className="dewey--search--section--motion"
      >
        <SearchSuggestionsQuestions />
      </motion.div>
      <motion.div
        variants={Variants.FadeInUpDelayed}
        initial={hasMounted ? "initial" : false}
        animate="animate"
        exit="exit"
        className="dewey--search--section--motion"
      >
        <SearchSuggestionsArticles />
      </motion.div>
    </div>
  );
}
